import React from "react";
import "./Components.css";
import arrow from "../../assets/arrow.svg";
import { useNavigate } from "react-router-dom";

const TextCapsules = ({
  text,
  textColor,
  bgColor,
  showArrow,
  isClickable,
  href,
  className
}) => {
  const navigate = useNavigate(); // Initialize navigate

  const handleClick = (e) => {
    console.log(href)
    if (isClickable) {
      e.preventDefault();
      if (href === "#contact-us") {
        const targetElement = document.querySelector(href);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        navigate(href); // Use navigate for internal routing
      }
    }
  };

  return (
    <div
      className={`text-capsules ${className} ${isClickable ? "clickable" : ""}`}
      style={{ background: bgColor, borderColor: textColor }}
      onClick={handleClick}
    >
      <div className="capsules-text" style={{ color: textColor }}>
        {text}
      </div>
      {showArrow && (
        <div className="arrow-svg">
          <img src={arrow} alt="arrow" />
        </div>
      )}
    </div>
  );
};

export default TextCapsules;
